import type { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { MenuMenusQuerySchema } from '~/services/api/generated'

// Mirrors MenuListRequest rules.
export const MenuMenus = (_context: NoContext): z.ZodType<z.output<typeof MenuMenusQuerySchema>> =>
  MenuMenusQuerySchema
